const textStyles = {
  headingKicker: {
    color: 'headingFontColor',
    display: 'block',
    fontFamily: 'heading',
    fontSize: 'md',
    fontWeight: 'bold',
    lineHeight: '1.1',
    mb: 1,
    textTransform: 'uppercase',
    _dark: {
      color: 'darkHeadingFontColor',
    },
  },
  headingCallout: {
    color: 'accentColor',
    display: 'block',
    fontFamily: 'heading',
    fontSize: { base: '3xl', md: '4xl' },
    fontWeight: 'bold',
    lineHeight: '1.1',
    m: 0,
    textTransform: 'uppercase',
    _dark: {
      color: 'primaryColor',
    },
  },
  modalHeader: {
    fontSize: '2xl',
  },
  modalProgressHeader: {
    fontSize: { base: 'sm', md: 'md' },
    textTransform: 'uppercase',
    fontWeight: '900',
    mt: -1,
    mb: 1,
  },
};

export default textStyles;
